import { apiGet, apiPost } from '../lib/api';
import { Character } from '../types/character';

export async function shareCharacter(character: Character): Promise<string> {
  const data = await apiPost<{ url: string }>('/api/characters/share', { character });
  return data.url;
}

export async function getSharedCharacter(shareId: string): Promise<Character | null> {
  try {
    return await apiGet<Character>(`/api/characters/shared/${shareId}`, false);
  } catch {
    return null;
  }
}

export async function importSharedCharacter(character: Character): Promise<Character> {
  const newCharacter: Character = {
    ...character,
    id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
    isStarred: false,
    lastModified: Date.now()
  };
  const localData = localStorage.getItem('character-creator-data');
  const characters = localData ? JSON.parse(localData) : [];
  characters.push(newCharacter);
  localStorage.setItem('character-creator-data', JSON.stringify(characters));
  return newCharacter;
}
